export const IS_SERVER_CONTEXT = typeof window === "undefined";
